import { call, put, takeEvery, all } from 'redux-saga/effects'
import invoiceTypes from './invoiceTypes'
import paymentTypes from './paymentTypes'
import * as invoiceActions from './invoiceActions'
import * as paymentctions from './paymentActions'
import MyPayments from '../../services/PaymentService/MyPayments'

export function * getInvoices ({ payload, onFailureCallback }) {
  try {
    const { data } = yield call(MyPayments.fetchInvoices, payload)
    yield put(invoiceActions.getInvoicesSuccess(data))
  } catch ({ message }) {
    yield put(invoiceActions.getInvoicesFailure(message))
    if (onFailureCallback) yield onFailureCallback()
  }
}

export function * getPayments ({ payload, onFailureCallback }) {
  try {
    const { data } = yield call(MyPayments.fetchPayments, payload)
    yield put(paymentctions.getPaymentsSuccess(data))
  } catch ({ message }) {
    yield put(paymentctions.getPaymentsFailure(message))
    if (onFailureCallback) yield onFailureCallback()
  }
}

export function * getPayoutTermsTypes () {
  try {
    const { data } = yield call(MyPayments.fetchPayoutTermsTypes)
    yield put(paymentctions.getPayoutTermsTypesSuccess(data))
  } catch ({ message }) {
    yield put(paymentctions.getPayoutTermsTypesFailure(message))
  }
}

export function * onGetInvoices () {
  yield takeEvery(invoiceTypes.GET_INVOICES, getInvoices)
}

export function * onGetPayments () {
  yield takeEvery(paymentTypes.GET_PAYMENTS, getPayments)
}

export function * onGetPayoutTermsTypes () {
  yield takeEvery(paymentTypes.GET_PAYOUT_TERMS_TYPES, getPayoutTermsTypes)
}

export function * myPaymentSaga () {
  yield all([
    call(onGetInvoices),
    call(onGetPayments),
    call(onGetPayoutTermsTypes)
  ])
}
